/* eslint-disable import/no-anonymous-default-export */
/* 
Copyright Beingana Jim Junior, 2021 and all the contributors. License Cn be found in the LICENCE file
*/

import { ReactAudio } from "./audio/react-audio.jsx";
import { FacebookPlayer } from "./facebook/index.jsx";
import { Image } from "./image/index.jsx";
import { ReactVideo } from "./video/react-video.jsx";
import { YoutubePlayer } from "./youtube/index.jsx";


export default {
    ReactAudio, 
    ReactVideo,
    Image,
    YoutubePlayer,
    FacebookPlayer
}
